import { useCurrentStateAndParams } from "@uirouter/react";
import { connect } from "react-redux";

import { TableNoData } from "app/components/React/Table/FlexTable/Big/FlexTableStatelessComponents";
import { i18nFilter } from "app/filters/i18nFilter";
import SegmentsAnalysisAdvancedEmptyWrapper from "app/pages/segments/analysis/SegmentsAnalysisAdvancedEmpty";
import { ConnectSegmentsGroupMarketingChannelsContainer } from "app/pages/segments/mmx/SegmentsGroupMarketingChannelsContainer";
import SegmentsSingleMarketingChannelsContainer from "app/pages/segments/mmx/SegmentsSingleMarketingChannelsContainer";
import { BoxContainer, GroupMMXContainer } from "app/pages/segments/mmx/styledComponents";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";

interface ISegmentsAnalysisMarketingChannelsContainer {
    params: any;
}

const SegmentsAnalysisMarketingChannelsContainer = (props: ISegmentsAnalysisMarketingChannelsContainer) => {
    const { params } = useCurrentStateAndParams();
    let ComponentToRender = null;
    let isUnavailable = false;
    switch (params?.mode) {
        case "single":
            ComponentToRender = SegmentsSingleMarketingChannelsContainer;
            break;
        case "group":
            const isMidTierUser = SegmentsUtils.isMidTierUser();
            if (isMidTierUser) {
                proNavigator.go("digitalsuite_segments-homepage");
            } else {
                isUnavailable = false;
                ComponentToRender = ConnectSegmentsGroupMarketingChannelsContainer;
            }
            break;
    }
    return ComponentToRender ? (
        isUnavailable ? (
            <GroupMMXContainer>
                <BoxContainer>
                    <TableNoData
                        icon="no-data"
                        messageTitle={i18nFilter()("segmentsmmx.coming.soon.compare")}
                    />
                </BoxContainer>
            </GroupMMXContainer>
        ) : (
            <SegmentsAnalysisAdvancedEmptyWrapper>
                <ComponentToRender {...props} />
            </SegmentsAnalysisAdvancedEmptyWrapper>
        )
    ) : null;
};

function mapStateToProps(store) {
    const {
        segmentsModule: { customSegmentsMeta, segmentsLoading },
    } = store;
    // const { params } = store.routing;
    return {
        segments: customSegmentsMeta?.Segments,
        organizationSegments: customSegmentsMeta?.AccountSegments,
        customSegmentsMeta: customSegmentsMeta,
        isLoading: segmentsLoading,
    };
}

export default connect(mapStateToProps, undefined)(SegmentsAnalysisMarketingChannelsContainer);
